module.exports = {
      id: "icon-audio-app-store-usage",
      viewBox: "0 0 122 41",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-audio-app-store",
      toString: function () {
        return this.url;
      }
    }